import { useMemo } from "react";
import { StreamingHelper } from "@scrile/streaming-client/build";
import { AudioAnalyzerOptions } from "@scrile/streaming-client/build/AudioAnalyzer";

interface Props {
  consumerOnAllStreamClosed?: () => void;
  /** Forwarded to StreamingHelper. The SDK already auto-runs the analyzer
   *  on the local mic stream after produceStream() and broadcasts
   *  `audio-activity` to remote consumers; passing onAudioActivity hooks
   *  a local-side callback (e.g. to drive the active-speaker indicator
   *  on the producer's own tile). */
  audioAnalyzerOptions?: AudioAnalyzerOptions;
}

export default function useWebRTC({ consumerOnAllStreamClosed, audioAnalyzerOptions }: Props = {}) {
  return useMemo(
    () => new StreamingHelper({ consumerOnAllStreamClosed, audioAnalyzerOptions }),
    // StreamingHelper is intentionally constructed once per hook instance.
    // Options are captured at first render — onAudioActivity closes over
    // React state setters, which are stable references, so this is safe.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
}
